import React from 'react'

import { Button, ButtonGroup, Delayed, Icon, Spinner } from '../../components'
import { useModelState } from '../../model-hooks/use-model-state'
import Chart from '../../models/chart'
import { QuoteFetchType } from '../../models/quote/constants'

interface LoadLatestDataButtonProps {
  chartModel: Chart
}

export function LoadLatestDataButton({ chartModel: chartModelUnwatched }: LoadLatestDataButtonProps) {
  const chartModel = useModelState(chartModelUnwatched, { watchProperties: ['quote'] })
  const chartLayoutModel = useModelState(chartModel.chart_layout(), { watchProperties: ['idea'] })
  const quoteModel = useModelState(chartModel.quote(), { watchProperties: ['isFetching'] })
  const [hasNewDataAvailable, setHasNewDataAvailable] = React.useState(false)

  React.useEffect(() => {
    if (!chartModel.getRefreshInterval() && chartLayoutModel.idea?.id) {
      // We will do a check here if we have correct new data
      chartModel.quote().isPossibleToFetchSequentialData().then(setHasNewDataAvailable)
    } else if (!chartLayoutModel.idea?.id) {
      setHasNewDataAvailable(false)

      if (chartModel.getRefreshInterval() === null && window.FinvizSettings.hasUserPremium) {
        chartModel.updateAttributes({ refreshData: true })
      }
    }
  }, [chartModel, chartLayoutModel.idea])

  const handleLoadLatestData = async () => {
    const promises = chartModel.getAllQuotes().map((quote) => quote.fetchData({ fetchType: QuoteFetchType.NewerData }))
    chartModel.updateAttributes({ refreshData: true })
    await Promise.all(promises)
    setHasNewDataAvailable(false)
    window.gtag?.('event', 'load-latest-data', { event_category: 'ideas' })
  }

  if (!hasNewDataAvailable) {
    return null
  }

  return (
    <ButtonGroup rounding="full" className="shadow-modal dark:shadow-modal-dark">
      <Button
        leftContent={
          quoteModel?.isFetching ? (
            <Delayed delayComponent={<Icon name="refresh" />}>
              <Spinner width={16} />
            </Delayed>
          ) : (
            'refresh'
          )
        }
        disabled={quoteModel?.isFetching}
        title="Load latest data"
        onClick={handleLoadLatestData}
      >
        Load latest data
      </Button>
    </ButtonGroup>
  )
}
